import cloneDeep from 'lodash/cloneDeep';
import React, { useCallback, useState, useMemo, useRef } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import PickerCol from './picker-col';
import { getYears, getMonths, getDays } from './utils';
const prefixCls = createPrefixCls('picker');
export const DatePicker = ({ defaultValue, dateRange, dateCols = ['year', 'month', 'day'], step, onChange }) => {
    const defaultValueRef = useRef(defaultValue);
    const [pickerValue, setPickerValue] = useState(defaultValueRef.current);
    const pickerIndex = useRef();
    const data = useMemo(() => {
        var _a, _b, _c;
        const arr = [];
        if (dateCols.includes('year')) {
            arr.push({
                col: 'year',
                data: getYears({
                    range: dateRange,
                    step: step.year
                })
            });
        }
        if (dateCols.includes('month')) {
            arr.push({
                col: 'month',
                data: getMonths({
                    year: (_a = pickerValue.year) === null || _a === void 0 ? void 0 : _a.value,
                    range: dateRange,
                    step: step.month
                })
            });
        }
        if (dateCols.includes('day')) {
            arr.push({
                col: 'day',
                data: getDays({
                    year: (_b = pickerValue.year) === null || _b === void 0 ? void 0 : _b.value,
                    month: (_c = pickerValue.month) === null || _c === void 0 ? void 0 : _c.value,
                    range: dateRange,
                    step: step.day
                })
            });
        }
        return arr;
    }, [dateCols, dateRange, pickerValue.month, pickerValue.year, step.day, step.month, step.year]);
    const handleChange = useCallback((el) => {
        return (index) => {
            var _a, _b;
            const col = el.col;
            pickerIndex.current = col;
            pickerValue[col] = el.data[index];
            if (col === 'year' && dateCols.includes('month')) {
                const nextYearMonths = getMonths({
                    year: pickerValue.year.value,
                    range: dateRange
                });
                if (!(nextYearMonths && nextYearMonths.find((el) => el.value === pickerValue.month.value))) {
                    pickerValue.month = nextYearMonths[0];
                }
            }
            if ((col === 'year' || col === 'month') && dateCols.includes('day')) {
                const nextMonthDays = getDays({
                    year: (_a = pickerValue.year) === null || _a === void 0 ? void 0 : _a.value,
                    month: (_b = pickerValue.month) === null || _b === void 0 ? void 0 : _b.value,
                    range: dateRange
                });
                if (!(nextMonthDays && nextMonthDays.find((el) => el.value === pickerValue.day.value))) {
                    pickerValue.day = nextMonthDays[0];
                }
            }
            setPickerValue(cloneDeep(pickerValue));
        };
    }, [dateCols, dateRange, pickerValue]);
    useUpdate(() => {
        pickerIndex.current && onChange && onChange(pickerValue, pickerIndex.current);
    }, [onChange, pickerIndex, pickerValue]);
    return (React.createElement("div", { className: prefixCls('content') },
        React.createElement("div", { className: prefixCls('mask') }),
        React.createElement("div", { className: prefixCls('indicator') }),
        React.createElement("div", { className: prefixCls('cols') }, data.map((el) => {
            return React.createElement(PickerCol, { key: el.col, data: el.data, value: pickerValue[el.col], onChange: handleChange(el) });
        }))));
};
export default DatePicker;
